import { SPINNER_VARIANT } from './spinnerUtils.js';

export const BUTTON_SIZE = {
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  modal: 'modal',
};
export const BUTTON_VARIANT = {
  main: 'main',
  destructive: 'destructive',
  secondary: 'secondary',
  tertiary: 'tertiary',
  ghost: 'ghost',
};
export const buttonSizes = Object.keys(BUTTON_SIZE);
export const buttonVariants = Object.keys(BUTTON_VARIANT);

export const BUTTON_VARIANT_CLASS_MAP = {
  [BUTTON_VARIANT.main]:
    'border-btn-accent bg-btn-accent text-white hover:bg-btn-accent-hover hover:border-btn-accent-hover focus:bg-btn-accent-hover active:bg-btn-accent-hover disabled:border-btn-disabled-border disabled:bg-btn-disabled-bg disabled:text-btn-disabled-text',
  [BUTTON_VARIANT.destructive]:
    'border-btn-accent bg-white text-btn-accent-text hover:bg-btn-accent hover:text-white disabled:border-btn-disabled-border disabled:bg-white disabled:text-btn-disabled-text',
  [BUTTON_VARIANT.secondary]:
    'border-btn-secondary-bg bg-btn-secondary-bg text-btn-secondary-text hover:opacity-80 disabled:border-btn-disabled-border disabled:bg-btn-disabled-bg disabled:text-btn-disabled-text',
  [BUTTON_VARIANT.tertiary]:
    'border-btn-tertiary-border bg-white text-btn-tertiary-text hover:bg-btn-tertiary-hover-bg disabled:border-btn-disabled-border disabled:text-btn-disabled-text',
  [BUTTON_VARIANT.ghost]:
    'border-white bg-transparent text-white hover:bg-white hover:text-black disabled:border-btn-ghost-disabled-border disabled:text-btn-ghost-disabled-text',
};

export const BUTTON_SIZE_CLASS_MAP = {
  [BUTTON_SIZE.sm]: {
    loading: 'py-[6px] pl-[10px] pr-[14px] text-[13px]',
    default: 'px-[16px] py-[5px] text-[13px]',
  },
  [BUTTON_SIZE.md]: {
    loading: 'py-2 pl-6 pr-7 text-[13px]',
    default: 'px-7 py-2 text-[13px]',
  },
  [BUTTON_SIZE.lg]: {
    loading: 'py-[12px] pl-9 pr-10 text-[13px]',
    default: 'px-10 py-[12px] text-[13px]',
  },
  [BUTTON_SIZE.modal]: {
    loading: 'w-full rounded-b-[10px] rounded-t-none py-4 pl-9 pr-10 text-sm',
    default: 'w-full rounded-b-[10px] rounded-t-none py-4 pl-9 pr-10 text-sm',
  },
};

export function getButtonSpinnerVariant(buttonVariant) {
  if (buttonVariant === BUTTON_VARIANT.main) {
    return SPINNER_VARIANT.white;
  }
  if (buttonVariant === BUTTON_VARIANT.destructive) {
    return SPINNER_VARIANT.red;
  }
  if (buttonVariant === BUTTON_VARIANT.secondary) {
    return SPINNER_VARIANT.white;
  }
  if (buttonVariant === BUTTON_VARIANT.tertiary) {
    return SPINNER_VARIANT.default;
  }
  if (buttonVariant === BUTTON_VARIANT.ghost) {
    return SPINNER_VARIANT.white;
  }
  return SPINNER_VARIANT.default;
}
